import * as React from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { AppUser } from '../../../../views/App/App';
import { Loader } from '../../../../components/Loader/Loader';
import { getClubProgramme } from '../../../../helpers/service/admin/clubProgrammes';
import { ClubProgrammeManageClubsContent } from './ClubProgrammeManageClubsContent';

type Props = {
  user: AppUser;
};

export const ClubProgrammeManageClubsPage: React.FC<Props> = ({ user }) => {
  const { programmeId } = useParams<{ programmeId: string }>();
  const history = useHistory();
  const location = useLocation<any>();

  const [isLoading, setIsLoading] = React.useState(true);
  const [programme, setProgramme] = React.useState<any>(null);
  const [error, setError] = React.useState<string>('');

  const loadProgramme = React.useCallback(() => {
    if (!programmeId) return;

    setIsLoading(true);
    setError('');

    getClubProgramme(user, String(programmeId))
      .then(p => {
        setProgramme(p);
        setIsLoading(false);
      })
      .catch(e => {
        console.error('ClubProgrammeManageClubsPage load error', e);
        setError('Failed to load programme.');
        setProgramme(null);
        setIsLoading(false);
      });
  }, [user, programmeId]);

  React.useEffect(() => {
    loadProgramme();
  }, [loadProgramme]);

  const onBackClick = () => {
    const backTo = location?.state?.from || {
      pathname: '/clubProgrammes',
      search: ''
    };

    history.push(backTo);
  };

  if (isLoading) return <Loader />;

  if (error || !programme) {
    return (
      <div className="pc-scroll pcProgrammeClubsPage">
        <div className="pcProgrammeClubsHeader">
          <button type="button" className="pcBackLink" onClick={onBackClick}>
            <span className="pcIcon pcIcon--back" aria-hidden="true" />
            <span>Back to activity programmes</span>
          </button>
          <h1 className="pcProgrammeClubsTitle">Programme</h1>
        </div>
        <div className="pcProgrammeClubsBody">
          <div className="pcCard pcProgrammeClubsEmptyState">{error || 'Programme was not found.'}</div>
        </div>
      </div>
    );
  }

  return (
    <ClubProgrammeManageClubsContent
      user={user}
      programme={programme}
      onBackClick={onBackClick}
      onProgrammeUpdated={(updated: any) => {
        setProgramme(updated);
      }}
    />
  );
};
